// App.tsx
import { useEffect } from 'react';
import AOS from 'aos';

// routes
import Routes from './routes/Routes';

// styles
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/scss/theme.scss';

const App = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    return <Routes />;
};

export default App;
